<template>
  <section id="employee-form">
    <header v-if="!isEmpty(currentEmployeeBranch)" class="mb-6">
      <div>
        <span class="h5">{{ `Вы привязаны к заведению: ${currentEmployeeBranch.name}` }}</span>
        &emsp;
        <vs-button
          type="border"
          color="primary"
          @click="detachEmployee"
        >
          Открепиться от заведения
        </vs-button>
      </div>
    </header>

    <vs-button color="primary" @click="handleRaiseClick">
      Прикрепиться к заведению
    </vs-button>

    <vs-popup
      title="Прикрепиться к заведению"
      :active.sync="popupRaise"
    >
      <form @submit.prevent>
        <vs-input
          v-model="form.branch_name"
          name="branch_name"
          v-validate="'required'"
          :label="$t('form.companyName')" />
        <vs-input
          name="branch_address"
          v-validate="'required'"
          :label="$t('form.companyАddress')"
          v-model="form.branch_address"/>
        <vs-input
          name="fake_branch_address"
          style="display: none"
          v-model="hidden_input"/>
        <vs-textarea class="mb-6" label="Комментарий" v-model='form.comment' />
        <vs-button
          button="submit"
          :disabled="!validateForm"
          @click="sendRequest"
        >
          Отправить
        </vs-button>
      </form>
    </vs-popup>
  </section>
</template>
<script>
import isEmpty from 'lodash/isEmpty.js'
import { mapGetters } from 'vuex'
import AuthService from '@/common/auth.service'
import { EMPLOYEE_BRANCH_DETACH } from '@/store/action.types'
import { REMOVE_EMPLOYEE_BRANCH } from '@/store/mutations.types'
export default {
  data() {
    return {
      hidden_input: '', // почемуто в последнем инпуте всегда появляется емейл. Сделал заглушку и спрятал инпут.
      form: {
        branch_name: '',
        branch_address: ''
      },
      popupRaise: false
    }
  },
  computed: {
    ...mapGetters(['currentEmployeeBranch', 'currentUser']),
    validateForm() {
      // check initial state for update
      return !this.errors.any() && this.form.branch_name !== '' && this.form.branch_address !== ''
    }
  },
  methods: {
    isEmpty(obj) {
      return isEmpty(obj)
    },
    handleRaiseClick() {
      this.popupRaise = true
      this.$km_track('Company', 'Click', 'Join')
    },
    detachEmployee() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Открепление от заведения`,
        text: `Вы уверены, что хотите открепиться от заведения?`,
        acceptText: 'Открепиться',
        cancelText: 'Отмена',
        accept: this.acceptEmployeeDetach
      })
    },
    acceptEmployeeDetach() {
      this.$vs.loading()
      const payload = {
        id: this.currentUser.id,
        name: this.currentUser.first_name,
        notify: this.$vs.notify
      }
      this.$store.dispatch(EMPLOYEE_BRANCH_DETACH, payload).then(() => {
        this.$store.commit(REMOVE_EMPLOYEE_BRANCH)
        this.$vs.loading.close()
      })
      this.$km_track('Company', 'Click', 'Detach')
    },
    sendRequest() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const payload = {
            'name': this.form.branch_name,
            'address': this.form.branch_address,
            'comment': this.form.comment
          }
          AuthService.joinEmployeeToBranch(payload).then(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Сообщение отправлено',
              text: 'Мы обработаем ваш запрос в течение дня'
            })
          })
          this.$km_track('JoinCompany', 'Click', 'Send')
        }
      })
    }
  }
}
</script>
